const supportedLanguages = ["en", "ar"];

function isLanguageSupported(language) {
  return supportedLanguages.includes(language);
}

function loadLocale() {
  const locale = localStorage && localStorage.locale;
  return isLanguageSupported(locale) ? locale : "en";
}

function setLocale(language, i18n) {
  if (isLanguageSupported(language)) {
    if (localStorage) {
      localStorage.setItem("locale", language);
    }
    i18n.locale = language;
  }
}

export { supportedLanguages, loadLocale, setLocale };
